import React,   {
  useState,
  useEffect
} from 'react'
import {
  Form,
  Switch
} from 'antd'

export const YesNo = props => {

  const form = Form.useFormInstance()
  const [ formContext, setFormContext ] = useState()

  const required = props.parent.attribs['data-required'] == 'true'
  
  useEffect(() => {

    if(form) {
      
      setFormContext(form)
    }

  }, [form])

  return <div className="wp-block-playmotivcloud-surveyanswer yesno">
    <Form.Item
      name={ props.parent.attribs['data-blockid'] }      
      valuePropName="checked"
      rules={[{ required: required, message: "Este campo es obligatorio" }]}
    >      
      <Switch 
        disabled={ formContext?.eventData?.instance.closed }
      />
    </Form.Item>
  </div>
}